import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import BasketNewUpsell from './components/BasketNewUpsell';

import './basket.scss';

const BasketPromoArea = ({
    executeNeccessaryCartSaving = null,
    deliveryPeriod = undefined,
}) => {
    const isEditBasketBlock = useMemo(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const hideParams = urlParams.get('hide') || '';
        const param = hideParams || '';
        return param?.includes('edit_basket');
    }, []);
    return (
        <BasketNewUpsell
            executeNeccessaryCartSaving={executeNeccessaryCartSaving}
            hidden={isEditBasketBlock}
            deliveryPeriod={deliveryPeriod}
        />
    );
};

BasketPromoArea.propTypes = {
    executeNeccessaryCartSaving: PropTypes.func,
    deliveryPeriod: PropTypes.string,
};

export default React.memo(BasketPromoArea);


/*

DEPRECATED ---------------------------------------------------------------------

const BasketMenuSelectionMoblieSlider = (props) => {
    const {
        preparedBasketAreas: {
            basketStyleModifier,
            promo: { header, backgroundType },
        },
    } = props;

    const rootClasses = cn({
        [basketStyleModifier]: true,
        'basket-menu-selections-root': true,
        'basket-menu-selections-root--white': backgroundType === 'white',
    });

    return (
        <div styleName={rootClasses}>
            {header !== 'off' && (
                <UIHeading level="3.2">
                    <span styleName="basket-menu-selections-title">
                        Добавить другие блюда?
                    </span>
                </UIHeading>
            )}
            <div styleName="basket-menu-selections-slider__list-container">
                <SelectionsMobileSlider realm="basket_realm" {...props} />
            </div>
        </div>
    );
};

BasketMenuSelectionMoblieSlider.propTypes = {
    closeHandler: PropTypes.func.isRequired,
    preparedBasketAreas: PropTypes.shape({
        basketStyleModifier: PropTypes.string.isRequired,
        promo: PropTypes.shape({
            header: PropTypes.oneOf([null, 'off']),
            backgroundType: PropTypes.oneOf([null, 'white']),
            isMenuSelectionsMobileSlider: PropTypes.bool.isRequired,
        }).isRequired,
    }).isRequired,
};

*/
